exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actions-wrapper {\n  display: flex;\n  align-items: flex-end;\n  column-gap: 12px;\n}\n\n.event-url-control {\n  margin-top: 24px;\n}\n\n.ticket-link {\n  display: block;\n  max-width: 350px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/manage/parse-tickets/parse-tickets.component.css
// module id = 591
// module chunks = 0